/** XeAgents.ai**/

/**
 * Free/personal email providers rejected by the "work email" gate on the free
 * pilot request form - a gmail.com or yahoo.com address is not evidence of a
 * company evaluating the product, so it is asked for again rather than accepted
 * and silently treated as a lead from nowhere.
 */
export const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.in",
  "yahoo.co.uk",
  "yahoo.com.au",
  "ymail.com",
  "rocketmail.com",
  "hotmail.com",
  "hotmail.co.uk",
  "outlook.com",
  "live.com",
  "msn.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "protonmail.com",
  "proton.me",
  "gmx.com",
  "gmx.net",
  "mail.com",
  "yandex.com",
  "yandex.ru",
  "rediffmail.com",
  "qq.com",
  "163.com",
  "126.com",
  "naver.com",
  "aim.com",
  "inbox.com",
  "fastmail.com",
  "hey.com",
  "zoho.com",
]);

/** Lowercases and strips a trailing dot so "Example.com." and "example.com" match. */
function normalizeDomain(domain: string): string {
  return domain.trim().toLowerCase().replace(/\.$/, "");
}

/**
 * True when the address's domain is not a known free/personal email provider.
 * Malformed input (no "@", empty domain) is treated as not a work email -
 * callers should validate email format separately and surface that error first.
 */
export function isWorkEmail(email: string): boolean {
  const domain = email.trim().toLowerCase().split("@")[1];
  if (!domain) return false;
  return !FREE_EMAIL_DOMAINS.has(normalizeDomain(domain));
}

export const WORK_EMAIL_ERROR_MESSAGE =
  "Please use your work email address - personal email providers like Gmail or Yahoo aren't accepted here.";
